import '~/js/modules/stickyNav';
import '~/js/modules/section-hero';
import popovers from '~/js/modules/popovers';
import QuickQuote from '~/js/components/global/QuickQuote';

popovers();

const popoverPlaceholder = document.querySelector('#popover #root');

ReactDOM.render(
  <QuickQuote
    schedulerModeIndex={ 4 }
    reference="oee"
    hasCountries={ false }
    hasResorts
    brand="beaches"
    noLabels
    hasOccupancy={ false }
    quoteButtonText="Continue"
    occupancyLabels={ false }
    startDatePlaceholderText="Check In"
    endDatePlaceholderText="Check Out"
  />,
  popoverPlaceholder
);

// Why tho ?

$('.js-popover').on('shown.bs.popover', () => {
  const popoverQQ = document.querySelector('.popover-content #root');

  $(popoverQQ).empty();

  ReactDOM.render(
    <QuickQuote
      schedulerModeIndex={ 4 }
      reference="oee"
      hasCountries={ false }
      hasResorts
      brand="beaches"
      noLabels
      groupID="21"
      eventID="7371"
      schedulerModeIndex="4"
      className="qq landing"
      hasOccupancy={ false }
      quoteButtonText="Continue"
      occupancyLabels={ false }
      startDatePlaceholderText="Check In"
      endDatePlaceholderText="Check Out"
      confirmationNumber
      notOeeRequest
      numberOfMonths={ 1 }
    />,
    popoverQQ
  );
});
